import store from "../../../store";
import pwa_map from "./map/pwa_map.vue";

window.pwa_map =  new Vue({
    store,
    el: 'div#pwa_map',

    name : "pwa_map",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        pwa_map,
    }
});
